import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { Box, Button, Alert } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

import { HeldTimesContext } from '../Root/CompetitionRoot';
import { Title } from '../Component/Title';
import { ReturnTopPage } from '../Utility/ReturnTopPage';
import { i18nContext } from '../i18n/i18nContext';

/**
 * 作品登録URLの有効期限が切れている場合に表示する
 */
export function KaguWorkTimeout() {

    const [t] = useTranslation();

    const {lng} = useContext(i18nContext);

    const heldTimesOption = useContext(HeldTimesContext);

    return(
        <>
            <Box>
                <Title>
                    {t("KaguWorkTimeout.Title", heldTimesOption)}
                </Title>
                <Alert icon={false} severity="error"
                    sx={{
                        mt:1,
                        textAlign:"left"
                    }}
                >
                    {t("KaguWorkTimeout.Text1")}<br/>
                    {t("KaguWorkTimeout.Text2")}
                </Alert>
                <Grid2 container spacing={1} mt={1}>
                    <Grid2>
                        <Button variant="outlined" onClick={() => ReturnTopPage(lng)}>{t("Common.Back")}</Button>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    );
}